import { lazy } from 'react';

import { useAuth } from '../../providers/AuthProvider';
import { UserRole, Permission } from '../../types';
import ProtectedRoute from '../../providers/ProtectedRoute';
import { SuspenseBoundary } from '../../components/ui/SuspenseBoundary';

const ProjectsPage = lazy(() => import('../projects/projects.page'));
const AdminUsersPage = lazy(() => import('../admin/UsersPage'));
const VerifierProjectsPage = lazy(() => import('../verifier/VerifierProjects.page'));

export function HomePage() {
  const { user } = useAuth();

  if (!user) return null;

  switch (user.role) {
    case UserRole.PRACTITIONER:
      return (
        <ProtectedRoute requiredPermission={Permission.ACCESS_PROJECTS}>
          <SuspenseBoundary>
            <ProjectsPage />
          </SuspenseBoundary>
        </ProtectedRoute>
      );
    case UserRole.ADMIN:
      return (
        <ProtectedRoute requiredPermission={Permission.MANAGE_USERS}>
          <SuspenseBoundary>
            <AdminUsersPage />
          </SuspenseBoundary>
        </ProtectedRoute>
      );
    case UserRole.VERIFIER:
      return (
        <ProtectedRoute requiredPermission={Permission.ACCESS_VERIFIER_POOL}>
          <SuspenseBoundary>
            <VerifierProjectsPage />
          </SuspenseBoundary>
        </ProtectedRoute>
      );
    default:
      return <div>No access to any dashboard</div>;
  }
}
